import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React, { memo } from 'react';
import classNames from 'classnames';
import styles from './FieldInlineActions.module.scss';
function FieldInlineActions({ actions = [], className }) {
    if (actions.length === 0)
        return _jsx(_Fragment, {});
    return (_jsx("div", Object.assign({ className: classNames(styles.actions, className) }, { children: actions.map((x) => (_jsx("div", Object.assign({ className: styles.action, onClick: (e) => {
                e.stopPropagation();
                x === null || x === void 0 ? void 0 : x.onClick(e);
            } }, { children: x.text }), x.text))) })));
}
export default memo(FieldInlineActions);
